module.exports = __webpack_public_path__ + "media/images/person-icon-02cec26a.svg";